"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var AttachmentDocIcon = function AttachmentDocIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.72,3.49H6.93a1.7,1.7,0,0,0-1.69,1.7V18.77a1.69,1.69,0,0,0,1.69,1.69H17.11a1.7,1.7,0,0,0,1.7-1.69V8.58Zm1.7,13.58H8.63v-1.7h6.79Zm0-3.4H8.63V12h6.79ZM12.87,9.43V4.77l4.67,4.66Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "23.96",
    height: "23.96",
    fill: "none"
  }));
};

var _default = AttachmentDocIcon;
exports["default"] = _default;
//# sourceMappingURL=AttachmentDoc.js.map